import {
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  FunctionField,
  useTranslate,
  NumberField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  Title,
  ShowOnlyNoEditTopToolbar,
} from "../../shared/components/index.js";

const showTruncs = () => {
  const t = useTranslate();
  const plugins = JSON.parse(localStorage.getItem("plugins"));

  return (
    <Show
      title={<Title source="client_phone" />}
      actions={<ShowOnlyNoEditTopToolbar />}
    >
      <SimpleShowLayout>
        <TextField source="title" />
        <FunctionField
          source="webhook_service_name"
          label="resources.Trunc.fields.webhook_service_name"
          render={(record) =>
            record.webhook_service_name &&
            t(
              `resources.Trunc.source.webhook_service_name.${record.webhook_service_name}`
            )
          }
        />
        <ReferenceField
          source="merchant_payment_gateway_id"
          reference="MerchantPaymentGateway"
          link="show"
        >
          <TextField source="name" />
        </ReferenceField>
        <FunctionField
          source="client_phone"
          render={(record) => (
            <a
              style={{ color: "#1976d2", textDecoration: "none" }}
              href={`/#/CLient/${record.client_id}/show`}
            >
              {record.client_phone}
            </a>
          )}
        />
        <ReferenceField
          source="client_id"
          reference="Client"
          link="show"
          label="resources.Trunc.fields.datex_id"
        >
          <TextField source="id" />
        </ReferenceField>
        <TextField source="description" />
        <TextField source="short_description" />
        {plugins && plugins.datexApiPayment && (
          <TextField source="session_id" />
        )}
        <NumberField source="order_id" />
        <FunctionField
          source="amount"
          render={(record) =>
            record.amount ? record.amount : record.amount_alt
          }
        />
        <JsonField
          source="transactions"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <JsonField
          source="payload"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
          sortable={false}
        />
        <FunctionField source="status" render={(record) => record.status} />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};

export default showTruncs;
